import { Link } from 'navigation'
import Image from 'next/image'

const LogIn = ({ t }) => {
  return (
    <>
      <h3 className='font-light text-[30px] md:text-[28px] my-6'>
        {t('logIn.title')}
      </h3>
      <p className='font-light mb-6'>
        {t.rich('logIn.goTobusiness', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
          linkToBusinessWeb: (chunks) => (
            <Link target='_blank' className='text-rolzo-gold' href={`https://${chunks}`}>
              {chunks}
            </Link>
          ),
        })}
      </p>
      <div>
      <Image priority={true}
src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_01.png'
alt=''
width={619}
height={366}
className='w-[75%] h-auto'
/>
</div>
    </>
  )
}

export default LogIn
